﻿import { default as classNames } from "classnames";

export function BadgeComponent({ color, children }: BadgeComponentProps) {
    // just for tailwindcss
    const unused = [
        <span className="text-bg-primary border-primary text-primary dark:text-primary"></span>,
        <span className="text-bg-secondary border-secondary text-secondary dark:text-secondary"></span>,
        <span className="text-bg-success border-success text-success dark:text-success"></span>,
        <span className="text-bg-danger border-danger text-danger dark:text-danger"></span>,
        <span className="text-bg-warning border-warning text-warning dark:text-warning"></span>,
        <span className="text-bg-info border-info text-info dark:text-info"></span>,
        <span className="text-bg-light border-light text-light dark:text-light"></span>,
        <span className="text-bg-dark border-dark text-dark dark:text-dark"></span>,
        <span className="text-bg-contrast border-contrast text-contrast dark:text-contrast"></span>,
        <span className="badge block rounded border text-xs dark:bg-transparent"></span>
    ];

    const classes = [
        "badge",
        "rounded",
        `border`,
        `border-${color}`,
        `text-xs`,
        `dark:text-${color}`,
        `dark:bg-transparent`,
        "block"
    ];

    if (color !== "contrast") {
        classes.push(`text-bg-${color}`);
    } else {
        classes.push(`text-${color}`);
    }
    
    return (
        <div>
            <span className={classNames(classes)}>{children}</span>
        </div>
    )
}

export interface BadgeComponentProps {
    color: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "contrast";
    children?: React.ReactNode;
}
